import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBwggAEnFSBqFEV-_iAcnjY8AC4U287N0E",
  authDomain: "my-firstproject-350605-a54a7.firebaseapp.com",
  projectId: "my-firstproject-350605-a54a7",
  storageBucket: "my-firstproject-350605-a54a7.firebasestorage.app",
  messagingSenderId: "867605422957",
  appId: "1:867605422957:web:f0529c5d88b4784d5f3064",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
